import { api } from '@/services'

async function useFreightOptions(cartId: string, zipcode: string) {
    let Response = null
    let Error = null

    const Controller = new AbortController()

    const MakeRequest = async () => {
        try {
            const resp = await api.post('Cart/CalcularFreteCarrinho', null, {
                params: {
                    CheckoutId: cartId,
                    cep: zipcode
                },
                signal: Controller.signal
            })
            if (resp.status === 200) {
                Response = resp.data
            }
        } catch (error) {
            Error = error
        }
    }

    await MakeRequest()

    Controller.abort()

    return [Response, Error]
}

export { useFreightOptions }
